import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Api } from "../../../../helpers/Api";
import Nav2 from "./Nav2";

const Nav = ({ user, dispatchUpdate }) => {
    const [permission, setPermission] = useState();
    const [showDrop, setShowDrop] = useState(false);
    const [clicked, setClicked] = useState(0);

    useEffect(() => {
        if (!user?.user) {
            window.location.href = "/auth/login";
        }

        Api.call("/users/me").then(response => {
            dispatchUpdate(response)
        })

        Api.call(`/users/${user.user.id}`).then(response => {
            setPermission(response.departments);
        })

    }, []);

    if(user?.user?.role === 12 || user?.user?.role === 13 ){
            return <Nav2 />
    }
    else{
    return <ul>
        <li  
        className={clicked === 0 ? 'nav-items bg-light' : 'nav-items'}>
            <Link to={user?.user?.role === 1 || user?.user?.role === 3 || user?.user?.role === 4 ? "/DepReport" :"/UpCommingEvents"}>
                <img src='../../../../images/dashboard.png' alt="Icon" />
                <span>Dashboard</span>
            </Link>
        </li>

        {user?.user?.role === 1 &&
            <li onClick={()=>{setClicked(1)}} 
            className={clicked === 1 ? 'nav-items bg-light' : 'nav-items'}>
                <Link to="/brands">
                    <img src='../../../../images/school-icon.png' alt="Icon" />
                    <span>Schools</span>
                </Link>
            </li>
        }

        {((permission != null && permission.length === 0) || user?.user?.role === 1) &&
            <li onClick={()=>{setClicked(2)}} 
            className={clicked === 2 ? 'nav-items bg-light' : 'nav-items'}>
                <Link to="/departments">
                    <img src='../../../../images/department-icon.png' alt="Icon" />
                    <span>Departments</span>
                </Link>
            </li>
        }

        {user?.user?.role === 1 &&
            <li onClick={()=>{setClicked(3)}} 
            className={clicked === 3 ? 'nav-items bg-light' : 'nav-items'}>
                <Link to="/users">
                    <img src='../../../../images/users-icon.png' alt="Icon" />
                    <span>Users</span>
                </Link>
            </li>
        }

        {/* <li className="nav-items">
            <Link to="/templates">
                <svg stroke="currentColor" fill="none" stroke-width="0" viewBox="0 0 24 24" focusable="false" className="chakra-icon css-13otjrl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"></path></svg>
                <span>Events</span>
            </Link>
        </li>
        <li className="nav-items">
            <Link to="/postEvent">
            <svg stroke="currentColor" fill="none" stroke-width="0" viewBox="0 0 24 24" focusable="false" className="chakra-icon css-13otjrl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"></path></svg>
                <span>Past</span>
                <span>Events</span>
            </Link>
        </li> */}
        
        <li className={clicked === 4 || clicked === 4.1 ?'nav-items event-drop-new bg-light':'nav-items event-drop-new'}>
            <a onClick={() => {
                setClicked(4)
                setShowDrop(!showDrop)}}>
                <div className={clicked === 4 ?"nav-content-drop bg-light":"nav-content-drop"}>
                    <img src='../../../../images/events-icon.png' alt="Icon" />
                    <span >Events</span>
                </div>
                <div className="drop-icon">
                    <img src='../../../../images/dropdown.svg' alt='icon' />
                </div>
            </a>
            {showDrop &&
                <div className="event-drop">
                    <ul>
                        <li className={clicked === 4 ? 'bg-light' : ''}>
                            <Link to="/UpCommingEvents">Upcoming Events</Link>
                        </li>
                        <li>
                            <Link to="/PastEvents">Past Events</Link>
                        </li>
                    </ul>
                </div>
            }
        </li>
        <li onClick={()=>{setClicked(5)}} 
            className={clicked === 5 ? 'nav-items bg-light' : 'nav-items'}>
            <Link to="/certificates">
                <img src='../../../../images/certificate-icon.png' alt="Icon" />
                <span>Certificates</span>
            </Link>
        </li>
        <li onClick={()=>{setClicked(6)}} 
            className={clicked === 6 ? 'nav-items bg-light' : 'nav-items'}>
            <Link to="/Report">
                <img src='../../../../images/reports.png' alt="Icon" />
                <span>Report</span>
            </Link>
        </li>
        {(user?.user?.role === 1 || user?.user?.role === 4 || user?.user?.role === 3) && <li onClick={()=>{setClicked(7)}} 
            className={clicked === 7 ? 'nav-items bg-light' : 'nav-items'}>
            <Link to="/adminRepo">
                <img src='../../../../images/reports.png' alt="Icon" />
                <span>Admin Report</span>
            </Link>
        </li>}
        <li onClick={()=>{setClicked(8)}} 
            className={clicked === 8 ? 'nav-items bg-light' : 'nav-items'}>
            <Link to="/mediaCollection">
            <img src='../../../../images/department-icon.png' alt="Icon" />
                <span>Media Collection</span>
            </Link>
        </li>
    </ul>
    }
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchUpdate: (user) => dispatch({ type: 'UPDATE_USER', data: user })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Nav)
